const ChevronDown = (props) => (
  <svg viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 1.06L6.494 7 13 1" stroke="currentColor" fill="none" />
  </svg>
)

export default ChevronDown
